<div class="investment-widget" (click)="openModal()">
  <!-- Header (same as other widgets) -->
  <div class="investment-header">
    <div class="investment-title">{{ title }}</div>

    <ng-container *ngIf="isEditMode">
      <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()" cdkOverlayOrigin
        #editTrigger="cdkOverlayOrigin">
        <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit" />
      </div>
      <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
        [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
        [toggleSizeDropdown]="toggleSizeDropdown">
      </app-widget-edit>
    </ng-container>

    <ng-container *ngIf="isAddMode">
      <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Add"
        (click)="addWidget.emit(); $event.stopPropagation()" />
    </ng-container>
  </div>

  <!-- Content -->
  <div class="investment-content" [ngClass]="{ 'small': size === 'small', 'medium': size !== 'small' }">
    <!-- Portfolio card (always present) -->
    <div class="portfolio-card">
      <div class="icon-wrapper">
        <div class="diamond-bg"></div>
        <div class="pill-icon">
          <img src="assets/icons/img-briefcase-01.svg" alt="Investment" />
        </div>
      </div>

      <div class="portfolio-info">
        <div class="portfolio-label">My portfolio:</div>
        <div class="portfolio-value">₹{{ portfolioValue | number:'1.0-0' }}</div>

        <div class="updated-section">
          <div class="updated-label">UPDATED</div>
          <div class="updated-date">{{ lastUpdated }}</div>
        </div>
      </div>
    </div>

    <!-- Holdings list – only in medium -->
    <ng-container *ngIf="size !== 'small'">
      <div class="holdings-section">
        <div class="holdings-title">My investments:</div>

        <div class="holding-item" *ngFor="let holding of holdings">
          <div class="holding-name">{{ holding.name }}</div>
          <div class="holding-value">${{ holding.value }}</div>
        </div>
      </div>
    </ng-container>
  </div>
</div>